import { remoteCall } from "../../remoteservice/RemoteServiceSuccess"
import { addURLParams } from "../../tools/URLTools"
const postMethods = async (url, data) => {
    const res = await remoteCall(url, { params: null, data: data, loadingState: 0 }, true)
    return res;
}
const postParamsMethods = async (url, data) => {
    const urls = addURLParams(url, data)
    console.log(url)
    const res = await remoteCall(urls, { params: null, data: {}, loadingState: 3 }, true)
    return res;
}
const putMethods = async (url, data) => {
    const res = await remoteCall(url, { params: null, data: data, type: 'put', loadingState: 3 }, true)
    return res;
}
const putparMethods = async (url, data) => {
    const urls = addURLParams(url, data)
    const res = await remoteCall(urls, { params: null, data: {}, type: 'put', loadingState: 3 }, true)
    return res;
}
const delMethods = async (url) => {
    const res = await remoteCall(url, { params: null, data: null, type: 'delete', loadingState: 3 }, true)
    return res;
}
class TableApi {
    // 下提税凭证genTaxVoucher  /dev-api/lms/fmpOrderImpl/genTaxVoucher
    static genTaxVoucher(data) {
        return postMethods('/dev-api/lms/fmpOrderImpl/genTaxVoucher', data)
    }
    // 转收入凭证/lms/fmpOrderImpl/genCFIncomeVoucher
    static genCFIncomeVoucher(data) {
        return postMethods('/dev-api/lms/fmpOrderImpl/genCFIncomeVoucher', data)
    }
    //提凭证/fmpCostStatement/createVoucher
    static createVoucher(data) {
        return postMethods('/dev-api/lms/fmpCostStatement/createVoucher', data)
    }
    //post接口
    static postMethods(url, data) {
        postMethods(url, data)
    }
    static postParamsMethods(url, par) {
        postParamsMethods(url, par)
    }
}
export default TableApi